import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export var toDto = function toDto(data, fieldsMap) {
  return Object.entries(data).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      _value = _ref2[1];
    var value = _value;
    var quizStepType = fieldsMap[name].quizStepType;
    if (quizStepType === 'rating') {
      var pairs = objectToKeyValueArray(value, name);
      var _iterator = _createForOfIteratorHelper(pairs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            fieldPath = _step$value[0],
            _value3 = _step$value[1];
          acc.fields.push({
            name: fieldPath,
            value: _value3,
            label: fieldsMap[name].label
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      acc.fields.push({
        name: name,
        value: value,
        label: fieldsMap[name].label
      });
    }
    return acc;
  }, {
    fields: []
  });
};
function isObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function objectToKeyValueArray(obj, selfName) {
  var pairs = [];
  var queue = [{
    current: obj,
    fieldPath: selfName
  }];
  while (queue.length > 0) {
    var item = queue.shift();
    if (item) {
      var current = item.current,
        fieldPath = item.fieldPath;
      for (var _i = 0, _Object$entries = Object.entries(current); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        var fieldName = fieldPath ? "".concat(fieldPath, ".").concat(key) : key;
        if (isObject(value)) {
          queue.push({
            current: value,
            fieldPath: fieldName
          });
        } else {
          pairs.push([fieldName, value]);
        }
      }
    }
  }
  pairs.sort(function (_ref3, _ref4) {
    var _ref5 = _slicedToArray(_ref3, 2),
      fieldName1 = _ref5[0],
      _value1 = _ref5[1];
    var _ref6 = _slicedToArray(_ref4, 2),
      fieldName2 = _ref6[0],
      _value2 = _ref6[1];
    return fieldName1.localeCompare(fieldName2);
  });
  return pairs;
}